import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnInit, OnChanges {
  @Input() src: string = '';
  @Input() alt: string = 'Avatar';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() showStatus: boolean = false;
  @Input() status: 'active' | 'inactive' | 'pending' = 'active';

  public showDefaultIcon: boolean = false;

  ngOnInit(): void {
    this.checkImageValidity();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['src']) {
      this.checkImageValidity();
    }
  }

  /**
   * Verifica se a imagem é válida
   */
  private checkImageValidity(): void {
    if (!this.src || 
        this.src.trim() === '' || 
        this.src === 'null' || 
        this.src === 'undefined' ||
        this.src.includes('default-avatar.png')) {
      this.showDefaultIcon = true;
    } else {
      this.showDefaultIcon = false;
    }
  }

  /**
   * Trata erro de carregamento da imagem
   */
  onImageError(): void {
    this.showDefaultIcon = true;
  }

  /**
   * Retorna as classes CSS baseadas no tamanho
   */
  getSizeClass(): string {
    return `avatar-${this.size}`;
  }

  /**
   * Retorna as classes CSS do status
   */
  getStatusClass(): string {
    return `status-indicator ${this.status}`;
  }
}
